module.exports = __webpack_public_path__ + "fonts/apercu-bold-pro.91efc41.woff2";